import {ecSendData, trackEvent, sendFacebookConversionsEvent} from "../../library/analytics";
import {popupInfoDialog} from "../../library/info-dialog";
import {addToCartAjax} from "./add-to-cart-personalized";
import {sendFloodLightEvent, showShoppingCart} from "./product-shopping-cart";
import {uploadImage} from "./upload-image";
import {getPriceFormat} from "./price-format";
import {configureHelpWidget} from "./help-widget";

$(document).ready(function() {
    $('#uploadedDesignPath').val('');

    $(document).on("change", ".qty-display, input[name='quantity']:checked", function() {
        trackEvent('PersonalizedProduct', 'ModifyQuantity', $('.qty-display').val());
    });

    $('.btnShowInfo').click(function() {
        $(this).parent().removeClass('visible-xs');
    });

    $('.pers-size-block').on('keypress', '.input-box', function(event) {
        if ((event.which != 8 && event.which != 46 && event.which != 44 && isNaN(String.fromCharCode(event.which))) || event.which == 32) {
            event.preventDefault();
            return false;
        }
    });

    doAfterFirstColorSelect();

    $('.contentColorSelect').click(function() {
        trackEvent('PersonalizedProduct', 'Color', $(this).children().attr('title'));
        let id = $(this).attr('id');
        let idArray = id.split("-");
        id = idArray[1];
        $('#color').val(id);
        $('#colorNameButton').html($(this).children().attr('title'));
        $('.divColorBackground').css('background-color', $(this).children().css('background-color'));


        let reverseInput = $('#reverse');
        let reverseBtn = reverseInput.parent();

        if (id == 104 || id == 106 || id == 107 || id == 108 || id == 109 || id == 111 || id == 112) {
            reverseInput.prop('checked', false);
            reverseBtn.hide();
            reverseBtn.addClass('not-allowed');
        } else if (reverseBtn.hasClass('not-allowed')) {
            reverseBtn.removeClass('not-allowed');
            reverseBtn.show();
        }

        updatePrice();
    });

    $('input[name=type]:radio').change(function() {
        trackEvent('PersonalizedProduct', 'Type', $(this).parent().text());
        if ($(this).val() == 'monocolor') {
            $('#option-trim').hide('fast');
            $('#option-color').show('fast');
            $('.contentColorSelect').first().click();
            $('input[name="trim"]').prop('checked', false);
        } else {
            $('#color').val(67);
            $('#option-color').hide('fast');
            $('#option-trim').show('fast');
            updatePrice();
        }
    });

    $('input[name=reverse]:checkbox').change(function() {
        trackEvent('PersonalizedProduct', 'GlassReversed', $(this).parent().text());
        updatePrice();
    });

    $('input[name=trim]:radio').change(function() {
        trackEvent('PersonalizedProduct', 'Trim', $(this).parent().text());
    });

    $('#keepProportion').change(function() {
        if ($(this).is(':checked')) {
            trackEvent('PersonalizedProduct', 'KeepProportions', 'yes');
        } else {
            trackEvent('PersonalizedProduct', 'KeepProportions', 'no');
        }
    });

    $('.upload-file-black').on('click', function() {
        $('#upload-file').click();
    });

    $('#upload-file').on('change', function(event) {
        let files = event.target.files;

        uploadImage(
            files,
            {prefix: 'personalized'},
            function(data) {
                $('#uploadedDesignPath').val(data.fileInfo.file);
                $('#uploadedDesignWidth').val(data.fileInfo.width);
                $('#uploadedDesignHeight').val(data.fileInfo.height);
                if (data.fileInfo.printable) {
                    $('#uploaded-image').attr('src', '/' + data.fileInfo.file).load(function() {
                        $('.upload-block').fadeOut('fast', function() {
                            $('.preview-block').fadeIn('fast', function() {
                                if (!$('#uploadedDesignWidth').val() || !$('#uploadedDesignHeight').val()) {
                                    $('#uploadedDesignWidth').val($('#uploaded-image').width());
                                    $('#uploadedDesignHeight').val($('#uploaded-image').height());
                                }
                                checkProportions();
                            });
                        });
                    });
                } else {
                    $('#no-preview-name').text(data.fileInfo.originalName);
                    $('.upload-block').fadeOut('fast', function() {
                        $('.no-preview-block').fadeIn('fast');
                    });
                }
                $('#btnReplaceDesign').fadeIn('fast');
                trackEvent('PersonalizedProduct', 'Upload', 'ok');
            },
            function(data) {
                replaceDesign();
                popupInfoDialog(data.error);
                trackEvent('PersonalizedProduct', 'Upload', 'error');
            }
        );
    });

    $('#fit-frame').draggable({
        containment: "parent",
        drag: function () {
            if (($('#uploadedDesignWidth').val() * $('#uploadedDesignHeight').val()) > 0) {
                updateShadows();
            }
        }
    });

    $('#btnReplaceDesign').click(function () {
        replaceDesign();
    });

    let sizeTimeOut;

    $('#width, #height').on('input',function () {
        let input = $(this);
        if ($('#keepProportion').is(':checked')) {
            autoCompleteSize(input.attr('id'));
        }
        checkProportions();
        updatePrice(true);

        if ($("#width").val() > 0 && $("#height").val() > 0) {
            clearTimeout(sizeTimeOut);
            sizeTimeOut = setTimeout(function(){
                trackEvent('PersonalizedProduct', 'Size', $("#width").val()+' x '+$("#height").val());
            }, 1000);
        }
    });

    $(document).on("click", ".btn-add-to-cart", function () {
        addToCart();
    });

    $(document).on("change", ".qty-display, input[name='quantity']:checked", function () {
        onQuantityChange();
    });

    $('.button-show-info').click(function() {
        let type = $(this).data('type');
        showInfoDialog(type);
    });

    $(document).on("click", ".description-btn", function () {
        trackEvent('PersonalizedProduct', 'Description', 'open/close');
    });

    $(document).on('change', 'input[name="complement"], input[class="cross-selling-select-product"]', function () {
        if ($(this).is(':checked') && ($(this).data('name') || $(this).data('reference'))) {
            trackEvent('PersonalizedProduct', 'Complement', $(this).data('name') || $(this).data('reference'));
        }
    });

    $(document).on('click', '.quantity-selector li', function() {
        let container = $(this).closest('.quantity-selector');
        let preview = container.find('.quantity-preview');
        let input = $(this).find('input');
        let quantity = input.val();

        container.find('li').removeClass('selected');
        $(this).addClass('selected');
        input.prop('checked', true);
        input.change();
        preview.text(quantity);
    });

    configureHelpWidget();
});

function doAfterFirstColorSelect() {
    $("#color").val(67);
}

function replaceDesign() {
    resetInput($('#upload-file'));
    $('#uploadedDesignPath').val('');
    $('#uploadedDesignWidth').val('');
    $('#uploadedDesignHeight').val('');

    if ($('.preview-block').is(':visible')) {
        $('.preview-block').fadeOut('fast', function () {
            $('.upload-block').fadeIn('fast');
        });
    } else {
        $('.no-preview-block').fadeOut('fast', function () {
            $('.upload-block').fadeIn('fast');
        });
    }
    $('#btnReplaceDesign').fadeOut('fast');
    checkProportions();
}

function resetInput(input) {
    input.wrap('<form>').parent('form').trigger('reset');
    input.unwrap();
}

function autoCompleteSize(base) {
    let widthDesign = $('#uploadedDesignWidth');
    let heightDesign = $('#uploadedDesignHeight');
    if (widthDesign.val() * heightDesign.val() > 0) {
        let widthInput = $('#width');
        let heightInput = $('#height');
        switch (base) {
            case "width":
                heightInput.removeClass('empty');
                heightInput.val(Math.round((widthInput.val() * heightDesign.val() / widthDesign.val()) * 100) / 100);
                break;
            case "height":
                widthInput.removeClass('empty');
                widthInput.val(Math.round((heightInput.val() * widthDesign.val() / heightDesign.val()) * 100) / 100);
                break;
        }
    }
}

function checkProportions() {
    let validPercent = 10;
    let originalProportion = $('#uploadedDesignWidth').val() / $('#uploadedDesignHeight').val();
    let actualProportion = $('#width').val() / $('#height').val();
    if (actualProportion > (originalProportion + (originalProportion * validPercent / 100)) || actualProportion < (originalProportion - (originalProportion * validPercent / 100))) {
        showFitFrame()
    } else {
        hideFitFrame()
    }
}

function showFitFrame() {
    $('#needPreview').val(true);
    $('#fit-image').show('fast');
    let frame = $('#fit-frame');
    let leftShadow = $('#fit-shadow-left');
    let rightShadow = $('#fit-shadow-right');
    let widthInput = $('#width');
    let heightInput = $('#height');
    let widthDesign = $('#uploadedDesignWidth');
    let heightDesign = $('#uploadedDesignHeight');
    let img = $('#uploaded-image');

    frame.show();
    leftShadow.show();
    rightShadow.show();
    frame.css('margin-top', "");
    frame.css('margin-left', "0");
    frame.css('left', "0");
    leftShadow.css('width', "0");
    leftShadow.css('height', "0");
    rightShadow.css('width', "0");
    rightShadow.css('height', "0");

    if (widthInput.val() > Math.round(heightInput.val() * widthDesign.val() / heightDesign.val())) {
        frame.css('width', img.width() + "px");
        frame.css('height', (img.width() * heightInput.val() / widthInput.val()) + "px");
        leftShadow.css('width', img.width() + "px");
        rightShadow.css('width', img.width() + "px");
    } else {
        frame.css('height', img.height() + "px");
        frame.css('width', (img.height() * widthInput.val() / heightInput.val()) + "px");
        leftShadow.css('height', img.height() + "px");
        rightShadow.css('height', img.height() + "px");
    }
    updateShadows();
}

function hideFitFrame() {
    $('#needPreview').val(false);
    $('#fit-image').hide('fast');
    $('#fit-frame').hide();
    $('#fit-shadow-left').hide();
    $('#fit-shadow-right').hide();
}

function updateShadows() {
    let frame = $('#fit-frame');
    let leftShadow = $('#fit-shadow-left');
    let rightShadow = $('#fit-shadow-right');
    let widthInput = $('#width');
    let heightInput = $('#height');
    let widthDesign = $('#uploadedDesignWidth');
    let heightDesign = $('#uploadedDesignHeight');
    let imageContainer = $('.preview-image');

    rightShadow.css('margin-top', "");
    rightShadow.css('margin-left', "0");
    if (widthInput.val() > Math.round(heightInput.val() * widthDesign.val() / heightDesign.val())) {
        leftShadow.css('height', frame.position().top - imageContainer.position().top + "px");
        rightShadow.css('margin-top', (frame.height() + leftShadow.height()) + "px");
        rightShadow.css('height', (imageContainer.height() - (frame.height() + leftShadow.height())) + "px");
    } else {
        // leftShadow.css('width', frame.position().left - imageContainer.position().left + "px");
        leftShadow.css('width', frame.position().left + "px");
        rightShadow.css("margin-left", (frame.width() + leftShadow.width()) + "px");
        rightShadow.css('width', (imageContainer.width() - (frame.width() + leftShadow.width())) + "px");
    }
}

function showInfoDialog(type) {
    $.post(
        '/ajax/service/info-dialog',
        {type: type},
        function (data) {
            popupInfoDialog(data.content);
        },
        'json'
    );
}

let updateAJAX;
function updatePrice(forceUpdateQuantitySelector = false) {
    if (typeof updateAJAX == 'object') {
        updateAJAX.abort();
    }

    if (forceUpdateQuantitySelector) $('input[name="quantity"][value="1"]').prop('checked', true);

    let productId = $('#productId').val();
    let width = $('#width').val();
    let height = $('#height').val();
    let quantity = parseInt($('input[name="quantity"]:checked').val());
    let color = $('#color').val();
    let reversed = $('input[name=reverse]:checked').val() ? $('input[name=reverse]:checked').val() : false;

    if (!isNaN(width) && width > 0 && !isNaN(height) && height > 0) {
        $('.btn-add-to-cart').attr('disabled', 'disabled');
        updateAJAX = $.post(
            '/ajax/product/calculate-custom-price',
            {
                productId: productId,
                width: width,
                height: height,
                quantity: quantity,
                options: {
                    color: color,
                    reversed: reversed
                }
            },
            function (data) {
                if (forceUpdateQuantitySelector) updateQuantitySelector(data.price);

                let total = data.price * quantity;

                if (total !== Math.floor(total)) {
                    total = total.toFixed(2);
                }

                total = getPriceFormat(total);
                $('.btn-item-price').text(total);
                $('.btn-add-to-cart').removeAttr('disabled');
            },
            'json'
        ).fail(function () {
            $('.btn-add-to-cart').removeAttr('disabled');
        });
    } else {
        $('.btn-item-price').text(0.00);
    }
}

function onQuantityChange() {
    updatePrice();
}

function addToCart() {
    let productId = $('#productId').val();
    let width = $('#width').val();
    let height = $('#height').val();
    let trim = $('input[name=trim]:checked').val() ? $('input[name=trim]:checked').val() : '' ;
    let keepProportion = $('input[name=keepProportion]:checked').val() ? $('input[name=keepProportion]:checked').val() : '' ;
    let reverse = $('input[name=reverse]:checked').val() ? $('input[name=reverse]:checked').val() : false;
    let color = $('#color').val();

    let file = $('#uploadedDesignPath').val();
    let needPreview = $('#needPreview').val();
    let uploadedImgWidth = $('#uploaded-image').width();
    if (needPreview && uploadedImgWidth > 0) {
        $('#uploaded-image').css('width', uploadedImgWidth + 'px');
    }
    let preview = $('.preview-block').html();

    let units = $('input[name="quantity"]:checked').val();
    if (units < 1) {
        units = 1;
    }
    let complements = [];
    $('input[name="complement"]:checked').each(function() {
        let complement = $(this);
        complements.push(
            {
                'id': complement.data('id'),
                'locked': complement.data('locked'),
                'linkToParent': complement.data('link-to-parent'),
                'options': {
                    'width': complement.data('width'),
                    'height': complement.data('height'),
                    'device': complement.data('device'),
                    'composition': complement.data('composition'),
                }
            }
        );
    });

    let crossSellingProducts = [];
    $('.cross-selling-select-product:checked').each(function() {
        let product = $(this);
        let options = {
            'size': product.data('size-id'),
            'originalProduct': $('#productId').val(),
            'personalizedImage': product.data('image'),
            'color': product.data('color'),
            'width': product.data('width'),
            'height': product.data('height'),
            'device': product.data('device'),
            'composition': product.data('composition'),
        };
        if (product.data('material-color')) {
            options['materialColor'] = product.data('material-color');
        }
        if (product.data('model')) {
            options['model'] = product.data('model');
        }
        if (product.data('pack')) {
            options['pack'] = product.data('pack');
        }
        crossSellingProducts.push(
            {
                'id': product.data('id'),
                'options': options,
                'locked': product.data('locked'),
                'linkToParent': product.data('link-to-parent')
            }
        );
    });
    let referrer = null;
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) referrer = document.referrer;

    addToCartAjax(
        {
            productId: productId,
            quantity: units,
            needPreview: needPreview,
            preview: preview,
            options: {
                width: width,
                height: height,
                color: color,
                trim: trim,
                keepProportion: keepProportion,
                mirrored: false,
                reversed: reverse,
                personalizedImage: file,
                // personalizedImageText: '', // @TODO: afegir nom de la imatge del client
                personalizedImageFromWeb: false,
                referrer: referrer,
            },
            complements,
            crossSellingProducts,
            convertUM: true,
            isLocked: true
        },
        function (data) {successAddToCart(data)},
        function (data) {failureAddToCart(data)}
    );
}

function successAddToCart(data) {
    // Reset size for unbroke images
    $('#width').val('');
    $('#height').val('');
    $('input[name=reverse]:checked').prop('checked', false);
    $('input[name=trim]:checked').prop('checked', false);
    $('input[name=keepProportion]').prop('checked', true);
    $('input[name=type]').prop('checked', false);
    $('input[name=type]:first').prop('checked', true).change();
    $('input[name=complement]:checked').prop('checked', false);
    $('input[name^="crossSelling-"]:checked').prop('checked', false);
    $('#reverse').parent().removeClass('not-allowed').show();
    
    if (data.cartItems) {
        $.each(data.cartItems, function (index, item) {
            if (item) {
                ecSendData(item.reference || '', item.name, item.price, item.quantity, item.colorApaCode, item.size, 'normal', 'add', null);
                trackEvent('PersonalizedProduct', 'AddToCart', $('h1').text());
                if (window.fbq) {
                    var payload = {
                        content_type: 'product',
                        content_name: item.name,
                        content_ids: [item.reference || ''],
                        contents: [{id: item.reference || '', quantity: item.quantity, price: item.price || 0}],
                        value: item.price || 0,
                        currency: item.currency || ''
                    };
                    sendFacebookConversionsEvent('AddToCart', payload);
                }
                if (window.pintrk) {
                    pintrk('track', 'AddToCart', {
                        value: item.price,
                        order_quantity: item.quantity,
                        currency: item.currency
                    });
                }
            }
        });
    }
    sendFloodLightEvent();
    replaceDesign();
    showShoppingCart();
}

function failureAddToCart(data) {
    trackEvent('PersonalizedProduct', 'AddToCart', 'error');
    if (data.errorCode == 'color') {
        $('html, body').animate({scrollTop: $('#buttonColor').offset().top - 150}, 'slow');
    }
    let errorMessage = data.errorMessage;
    if (typeof errorMessage !== 'string') {
        errorMessage = 'Error';
    }
    popupInfoDialog(errorMessage);
}

function updateQuantitySelector(price)
{
    $.post(
        '/ajax/personalized-services/get-quantity-selector',
        {
            productId: $("#productId").val(),
            price: price
        },
        function(data){
            if (data.quantitySelector && data.quantitySelector.length) {
                $('.add-to-cart-quantity-selector').html(data.quantitySelector);
            }
        }
    );
}


(function () {
    'use strict';

    function togglePanel(button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            // Cerrar
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            // forzar reflow para que la transición arranque
            void panel.offsetHeight;
            panel.style.setProperty('--tv-panel-height', '0px');
            button.setAttribute('aria-expanded', 'false');
            // ocultar al terminar la transición
            panel.addEventListener('transitionend', function handler() {
                panel.hidden = true;
                panel.removeEventListener('transitionend', handler);
            });
        } else {
            // Abrir
            panel.hidden = false;
            panel.style.setProperty('--tv-panel-height', panel.scrollHeight + 'px');
            button.setAttribute('aria-expanded', 'true');
        }
    }

    document.addEventListener('click', function (e) {
        var button = e.target.closest('.tv-faqs__header');
        if (!button) return;
        togglePanel(button);
    });
})();